<template>
    <div style="background-color: white;min-height: 650px;padding: 20px;box-sizing: border-box;">

        <div v-if="loading" style="text-align: center; padding: 40px">
            <i class="el-icon-loading" style="font-size: 24px"></i>
            <p>Loading...</p>
        </div>
        <div v-else-if="error" style="text-align: center; padding: 40px; color: #f56c6c">
            <p>⚠️ Unable to load posts</p>
            <p style="font-size: 12px; color: #999">{{ error }}</p>
            <el-button type="primary" size="small" @click="fetchData" style="margin-top: 10px">Retry</el-button>
        </div>
        <div v-else>
            <div v-if="bannerList.length > 0" style="display:flex;height: 200px;gap: 20px;">
                <div v-for="(item, index) in bannerList" :key="index" style="cursor: pointer;"
                    @click="doShowNewsInfo(item)">
                    <img v-if="item.image_url" :src="item.image_url" style="width: 300px;height: 100%;border-radius: 5px; object-fit: cover;">
                    <div v-else style="width: 300px;height: 100%;border-radius: 5px; background-color: #f5f7fa; display: flex; align-items: center; justify-content: center; color: #999;">
                        No Image
                    </div>
                </div>
            </div>

            <div style="margin-top: 20px;">
                <div v-for="(news, index) in dataList" :key="index" class="news-item" @click="doShowNewsInfo(news)">
                    <div style="flex: 1;box-sizing: border-box;">
                        <div class="news_meta">
                            <span class="news_date">{{ formatDisplayDate(news) }}</span>
                            <span v-if="news.user_name" class="news_author" :style="getUserTagStyle(news.user_name)">{{ news.user_name }}</span>
                        </div>
                        <h2 class="news_title">{{ news.post_title || news.title || '' }}</h2>
                        <div class="news_intro markdown-preview" v-html="renderMarkdown(news.post_content)"></div>
                        <div v-if="news.project_tags && news.project_tags.length > 0" class="news_tags">
                            <span v-for="(tag, tagIndex) in news.project_tags" :key="tagIndex" class="news_tag">{{ tag }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="dataList.length === 0" style="text-align: center; padding: 40px; color: #999">
                    <p>No posts available</p>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="showNewsDialog" width="60%" :show-close="true">
            <div class="news-dialog-content">
                <div class="news-dialog-meta">
                    <span class="news-dialog-date">{{ formatDisplayDate(selectNews) }}</span>
                    <span v-if="selectNews.user_name" class="news-dialog-author" :style="getUserTagStyle(selectNews.user_name)">{{ selectNews.user_name }}</span>
                </div>
                <h2 class="news-dialog-title">{{ selectNews.post_title || selectNews.title || '' }}</h2>
                <div class="news-dialog-content-text markdown-content" v-html="renderMarkdown(selectNews.post_content)"></div>
                <div v-if="selectNews.project_tags && selectNews.project_tags.length > 0" class="news-dialog-tags">
                    <span v-for="(tag, tagIndex) in selectNews.project_tags" :key="tagIndex" class="news-dialog-tag">{{ tag }}</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    getUserPulses,
    viewPostInGuestMode
} from '../../api/eae'
import '../../assets/common/font.css'
export default ({
    name: 'index',
    data() {
        return {
            bannerList: [],
            dataList: [],
            showNewsDialog: false,
            selectNews: {},
            loading: false,
            error: null
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {

        doShowNewsInfo(news) {
            // Use the formatted news data directly (UserPulse data is already complete)
            this.selectNews = news;
            this.showNewsDialog = true;
        },

        getPostId(post) {
            if (!post._id) return '';
            if (typeof post._id === 'string') {
                return post._id;
            }
            if (typeof post._id === 'object') {
                return post._id.$id || post._id.$oid || post._id.toString() || '';
            }
            return String(post._id);
        },

        formatNewsData(pulse) {
            // Format UserPulse data to match expected structure
            // UserPulse has: id, created_at, content, and other fields
            return {
                post_title: pulse.title || pulse.post_title || '',
                post_content: pulse.content || pulse.post_content || '',
                create_time: pulse.created_at || pulse.create_time || 0,
                create_time_time: pulse.created_at || pulse.create_time || 0,
                display_date: pulse.display_date || null,
                project_tags: pulse.project_tags || pulse.tags || [],
                image_url: this.getPulseImage(pulse),
                topped: pulse.topped || 'NO',
                user_name: pulse.user_name || pulse.userName || '',
                _id: pulse.id ? { $id: pulse.id } : pulse._id,
                // Keep original pulse data for detail view
                originalPulse: pulse
            };
        },
        getComputedTimestamp(news) {
            // Prioritize display_date, fall back to created_at
            if (news.display_date) {
                return news.display_date * 1000;
            } else if (news.create_time_time) {
                return news.create_time * 1000;
            } else if (news.create_time) {
                return news.create_time * 1000;
            } else if (news.created_at) {
                return news.created_at * 1000;
            }
            return 0;
        },
        formatDisplayDate(news) {
            // Use computed timestamp for display
            const dateToUse = this.getComputedTimestamp(news);
            
            if (dateToUse) {
                return this.$dayjs(dateToUse).format("MMMM D, YYYY");
            }
            return '';
        },
        getUserTagStyle(userName) {
            // Map user names to colors
            const colorMap = {
                'World Economics Cup': {
                    backgroundColor: '#FFD700', // gold
                    color: '#333'
                },
                'International Psychology Olympiad': {
                    backgroundColor: '#FF69B4', // pink red
                    color: '#fff'
                },
                'International Business Olympiad': {
                    backgroundColor: '#1E3A8A', // business blue
                    color: '#fff'
                },
                'International Environmental Olympiad': {
                    backgroundColor: '#10B981', // green
                    color: '#fff'
                },
                'International Finance Olympiad': {
                    backgroundColor: '#EF4444', // red
                    color: '#fff'
                },
                'Next Idea Matters': {
                    backgroundColor: '#FCD34D', // yellow
                    color: '#333'
                },
                'World Academic Olympics': {
                    backgroundColor: '#3B82F6', // blue
                    color: '#fff'
                }
            };

            // Check for exact match or partial match
            for (let key in colorMap) {
                if (userName && userName.includes(key)) {
                    return colorMap[key];
                }
            }

            // Default theme color
            return {
                backgroundColor: '#ffefed',
                color: '#666'
            };
        },

        getPulseImage(pulse) {
            // Get image from UserPulse data structure
            if (pulse.image_url) {
                return pulse.image_url;
            }
            if (pulse.image) {
                return pulse.image;
            }
            if (pulse.images && pulse.images.length > 0) {
                return pulse.images[0];
            }
            if (pulse.fileList && pulse.fileList.length > 0) {
                const imageItem = pulse.fileList[0];
                if (typeof imageItem === 'string') {
                    return imageItem;
                }
                return imageItem.url || imageItem.src || imageItem.data?.url || null;
            }
            return null;
        },

        renderMarkdown(content) {
            if (!content) return '';
            
            // Simple markdown to HTML conversion
            let html = content
                // Headers
                .replace(/^### (.*$)/gim, '<h3>$1</h3>')
                .replace(/^## (.*$)/gim, '<h2>$1</h2>')
                .replace(/^# (.*$)/gim, '<h1>$1</h1>')
                // Bold
                .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                .replace(/__([^_]+)__/g, '<strong>$1</strong>')
                // Italic
                .replace(/\*([^*]+)\*/g, '<em>$1</em>')
                .replace(/_([^_]+)_/g, '<em>$1</em>')
                // Links
                .replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
                // Code blocks
                .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                // Inline code
                .replace(/`([^`]+)`/g, '<code>$1</code>')
                // Line breaks
                .replace(/\n/g, '<br>');
            
            return html;
        },

        fetchData() {
            this.loading = true;
            this.error = null;

            const user_ids = [
                '6743d93894c7841b468b456d',
                '68b11ba594c784d9568b4596',
                '68b11bcc94c784da568b458f',
                '68b11c6894c784d6568b458f',
                '68b11c2694c78460328b4571',
                '68b11d7c94c784d4568b4586',
                '68b11b7894c784da568b458e',
                '68b11b4194c784d6568b458e'
            ];

            getUserPulses(user_ids)
                .then((res) => {
                    this.loading = false;
                    if (res.data && res.data.code === 0 && res.data.data) {
                        let result = res.data.data.map(post => this.formatNewsData(post));
                        
                        // Separate banner and regular list
                        this.bannerList = [];
                        result.forEach((item) => {
                            if (item.topped == 'YES') {
                                if (this.bannerList.length <= 3) {
                                    this.bannerList.push(item);
                                }
                            }
                        });
                        
                        // Sort by computed timestamp (prioritize display_date, fall back to created_at)
                        this.dataList = result
                            .sort((a, b) => {
                                const timeA = this.getComputedTimestamp(a);
                                const timeB = this.getComputedTimestamp(b);
                                return timeB - timeA; // Newest first
                            })
                            .filter((item) => {
                                return !item.topped || item.topped == 'NO';
                            });
                    } else {
                        this.dataList = [];
                        this.bannerList = [];
                        this.error = res.data?.msg || 'No data returned';
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.error = err.message || 'Failed to load posts';
                    console.error('Failed to load posts:', err);
                });
        },
        compare(property, desc) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                if (desc == true) {
                    // 升序排列
                    return value1 - value2;
                } else {
                    // 降序排列
                    return value2 - value1;
                }
            }
        }
    }
})
</script>
<style scoped lang="scss">
.news-item {
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
    min-height: 100px;
    border: 1px solid #E6D7D7;
    padding: 20px 16px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 20px;

    .news_meta {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;
    }

    .news_date {
        color: #FC6556;
        font-size: 14px;
        font-family: centurygothic;
    }

    .news_author {
        display: inline-block;
        font-size: 12px;
        font-family: centurygothic;
        padding: 4px 12px;
        border-radius: 12px;
    }

    .news_title {
        color: #333;
        font-size: 8px;
        font-family: centurygothic_bold;
        font-weight: bold;
        margin: 0 0 12px 0;
        line-height: 1.4;
    }

    .news_intro {
        color: #666;
        font-size: 15px;
        line-height: 22px;
        font-family: centurygothic;
        margin-bottom: 12px;

        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        text-overflow: ellipsis;
        
        &.markdown-preview {
            // Style markdown elements in preview
            /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
                font-size: 16px !important;
                font-weight: 600 !important;
                margin: 0 !important;
                line-height: inherit !important;
                display: inline !important;
            }
            strong {
                font-weight: 600;
            }
            em {
                font-style: italic;
            }
            code {
                background-color: #f5f5f5;
                padding: 2px 4px;
                border-radius: 3px;
                font-size: 0.9em;
            }
            pre {
                display: none; // Hide code blocks in preview
            }
            a {
                color: #409eff;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .news_tags {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-top: 12px;
    }

    .news_tag {
        display: inline-block;
        color: #666;
        font-size: 12px;
        font-family: centurygothic;
        padding: 4px 12px;
        background-color: #ffefed;
        border-radius: 12px;
    }
}

.news-content {
    color: #666;
    font-size: 14px;
    line-height: 20px;
    white-space: pre-wrap;
    word-break: keep-all;
}

.markdown-content {
    h1, h2, h3, h4, h5, h6 {
        font-family: "PT Sans", "SF UI Display", ".PingFang SC", "PingFang SC",
            "Neue Haas Grotesk Text Pro", "Arial Nova", "Segoe UI", "Microsoft YaHei",
            "Microsoft JhengHei", "Helvetica Neue", "Source Han Sans SC",
            "Noto Sans CJK SC", "Source Han Sans CN", "Noto Sans SC",
            "Source Han Sans TC", "Noto Sans CJK TC", "Hiragino Sans GB", sans-serif;
        text-rendering: optimizelegibility;
        margin-top: 1em;
        margin-bottom: 0.5em;
        font-weight: 600;
        line-height: 1.5;
        color: #333333;
    }
    h1 {
        font-size: 1.5rem;
    }
    h2 {
        font-size: 1.25rem;
    }
    h3 {
        font-size: 1.1rem;
    }
    strong {
        font-weight: 600;
    }
    em {
        font-style: italic;
    }
    code {
        background-color: #f5f5f5;
        padding: 2px 6px;
        border-radius: 3px;
        font-size: 0.9em;
        font-family: 'Courier New', monospace;
    }
    pre {
        background-color: #f5f5f5;
        padding: 10px;
        border-radius: 4px;
        overflow-x: auto;
        code {
            background: none;
            padding: 0;
        }
    }
    a {
        color: #409eff;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
    ul, ol {
        margin: 0.5em 0;
        padding-left: 2em;
    }
    ul {
        list-style-type: disc;
    }
    ol {
        list-style-type: decimal;
    }
    p {
        margin: 0.5em 0;
    }
}

.news-dialog-content {
    padding: 10px;
}

.news-dialog-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.news-dialog-date {
    color: #FC6556;
    font-size: 14px;
    font-family: centurygothic;
}

.news-dialog-author {
    display: inline-block;
    font-size: 12px;
    font-family: centurygothic;
    padding: 4px 12px;
    border-radius: 12px;
}

.news-dialog-title {
    color: #333;
    font-size: 18px;
    font-family: centurygothic_bold;
    font-weight: bold;
    margin: 0 0 16px 0;
    line-height: 1.4;
}

.news-dialog-content-text {
    color: #666;
    font-size: 15px;
    line-height: 22px;
    font-family: centurygothic;
    margin-bottom: 20px;
    word-break: keep-all;
    word-wrap: normal;
    overflow-wrap: normal;
}

.news-dialog-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #E6D7D7;
}

.news-dialog-tag {
    display: inline-block;
    color: #666;
    font-size: 12px;
    font-family: centurygothic;
    padding: 4px 12px;
    background-color: #ffefed;
    border-radius: 12px;
}
</style>